import { Outlet, RouteObject } from 'react-router';

import { AppContainerWithMenu } from '@sternum/web/features/appContainerWithMenu/AppContainerWithMenu.component';
import { ProtectedRoute } from '@sternum/web/routes/ProtectedRoute';
import { lazyImport } from '@sternum/web/utils/lazyImport';

import { userPaths } from './paths';

const { Profile } = lazyImport(() => import('../views/profile'), 'Profile');
const { ManageUsers } = lazyImport(() => import('../views/manageUsers'), 'ManageUsers');

function Layout() {
  return (
    <ProtectedRoute>
      <AppContainerWithMenu>
        <Outlet />
      </AppContainerWithMenu>
    </ProtectedRoute>
  );
}

export const userRoutes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { path: userPaths.profile.relative, element: <Profile /> },
      { path: userPaths.manageUsers.relative, element: <ManageUsers /> },
    ],
  },
];
